import { render } from "./CompositionQuiz.vue?vue&type=template&id=44dce8a3&scoped=true&ts=true"
import script from "./CompositionQuiz.vue?vue&type=script&lang=ts"
export * from "./CompositionQuiz.vue?vue&type=script&lang=ts"

import "./CompositionQuiz.vue?vue&type=style&index=0&id=44dce8a3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44dce8a3"]])

export default __exports__